<template>
    <div class="container mar-bt2">
        <div class="row mar-tp1 mar-bt2 align-items-center">
            <i class="fa fa-bandcamp fa-lg mar-r1 text-info"></i>
            <h6>当前位置&nbsp;>&nbsp;<router-link to="/home">首页</router-link>&nbsp;>&nbsp;产品与服务</h6>
        </div>
        <Prolist />
    </div>
</template>
<script>
import Prolist from '../components/Prolist';
export default {    
    components:{
        Prolist
    }
    
}
</script>
<style scoped>

</style>